<template>
  <div class="invite-reward">
    <!-- 表单 -->
    <el-form size="small" ref="form" :model="form" label-width="180px">
      <div class="common-form">邀请有礼设置</div>
      
      <!-- 第一级别设置 -->
      <div class="level-section">
        <h3>第一级别奖励</h3>
        <el-form-item label="奖励金额">
          <el-input v-model="form.level1.reward" class="max-w460">
            <template slot="append">元</template>
          </el-input>
        </el-form-item>
        <el-form-item label="需要邀请人数">
          <el-input v-model="form.level1.required_invites" class="max-w460">
            <template slot="append">人</template>
          </el-input>
        </el-form-item>
      </div>
      
      <!-- 第二级别设置 -->
      <div class="level-section">
        <h3>第二级别奖励</h3>
        <el-form-item label="奖励金额">
          <el-input v-model="form.level2.reward" class="max-w460">
            <template slot="append">元</template>
          </el-input>
        </el-form-item>
        <el-form-item label="需要邀请人数">
          <el-input v-model="form.level2.required_invites" class="max-w460">
            <template slot="append">人</template>
          </el-input>
        </el-form-item>
      </div>
      
      <!-- 第三级别设置 -->
      <div class="level-section">
        <h3>第三级别奖励</h3>
        <el-form-item label="奖励金额">
          <el-input v-model="form.level3.reward" class="max-w460">
            <template slot="append">元</template>
          </el-input>
        </el-form-item>
        <el-form-item label="需要邀请人数">
          <el-input v-model="form.level3.required_invites" class="max-w460">
            <template slot="append">人</template>
          </el-input>
        </el-form-item>
      </div>
      
      <!-- 其他设置 -->
      <div class="common-form">其他设置</div>
      <el-form-item label="活动规则说明">
        <el-input
          type="textarea"
          :rows="4"
          v-model="form.description"
          class="max-w460"
          placeholder="请输入活动规则说明">
        </el-input>
      </el-form-item>
      
      <!-- 提交 -->
      <div class="common-button-wrapper">
        <el-button type="primary" @click="onSubmit" :loading="loading">提交</el-button>
      </div>
    </el-form> <!-- 这里修复了闭合标签 -->
  </div>
</template>

<script>
  import SettingApi from '@/api/setting.js';

  export default {
    data() {
      return {
        /* 表单数据 */
        form: {
          level1: {
            reward: '',
            required_invites: ''
          },
          level2: {
            reward: '',
            required_invites: ''
          },
          level3: {
            reward: '',
            required_invites: ''
          },
          validity_period: '',
          description: ''
        },
        loading: false,
      };
    },
    created() {
      this.getData()
    },

    methods: {
      getData() {
        let self = this;
        // 注意：这里需要根据实际API调整
        SettingApi.inviteRewardDetail({}, true)
          .then(data => {
            let vars = data.data.vars.values;
            self.form.level1.reward = vars.level1.reward;
            self.form.level1.required_invites = vars.level1.required_invites;
            self.form.level2.reward = vars.level2.reward;
            self.form.level2.required_invites = vars.level2.required_invites;
            self.form.level3.reward = vars.level3.reward;
            self.form.level3.required_invites = vars.level3.required_invites;
            self.form.validity_period = vars.validity_period;
            self.form.description = vars.description;
          })
          .catch(error => {});
      },
      // 提交表单
      onSubmit() {
        let self = this;
        self.loading = true;
        let params = this.form;
        // 注意：这里需要根据实际API调整
        SettingApi.editInviteReward(params, true)
          .then(data => {
            self.loading = false;
            self.$message({
              message: '恭喜你，邀请有礼设置成功',
              type: 'success'
            });
          })
          .catch(error => {
            self.loading = false;
          });
      }
    }
  };
</script>

<style scoped>
  .invite-reward {
    padding: 20px;
  }
  
  .level-section {
    margin-bottom: 30px;
    padding: 15px;
    border: 1px solid #e6e6e6;
    border-radius: 4px;
  }
  
  .level-section h3 {
    margin-top: 0;
    margin-bottom: 15px;
    padding-bottom: 10px;
    border-bottom: 1px solid #e6e6e6;
    color: #409EFF;
  }
  
  .max-w460 {
    max-width: 460px;
  }
  
  .common-form {
    font-size: 16px;
    font-weight: bold;
    margin: 20px 0 15px 0;
    padding-bottom: 10px;
    border-bottom: 1px solid #e6e6e6;
  }
  
  .common-button-wrapper {
    margin-top: 30px;
    padding-left: 180px;
  }
  
  .tips {
    color: #ccc;
    font-size: 12px;
    margin-top: 5px;
  }
</style>


// WEBPACK FOOTER //
// src/views/setting/invitation/index.vue